// import HomePage from '../pages/module/home/HomePage';
import GeneralRegistrationsPage from '../pages/module/registrations/general/GeneralRegistrationsPage';
import OperationalRegistrationsPage from '../pages/module/registrations/operational/OperationalRegistrationsPage';
import FinancialRegistrationsPage from '../pages/module/registrations/financial/FinancialRegistrationsPage';
import ImportPage from '../pages/module/import/ImportPage';
import ExportPage from '../pages/module/export/ExportPage';
import FinancialPage from '../pages/module/financial/FinancialPage';
import PricingTarifarioModulePage from '../pages/module/pricing/tarifarios/PricingTarifarioModulePage';

import i18n from '../i18n';
import { ModuloPerfilUtils } from '../components/perfil/perfil-utils';
import AgenciamentoImportacaoPageAereo from '../pages/module/agenciamento/AgenciamentoImportacaoPageAereo';
import AgenciamentoImportacaoPageMaritmo from '../pages/module/agenciamento/AgenciamentoImportacaoPageMaritmo';
import AgenciamentoExportacaoPageAereo from '../pages/module/agenciamento/AgenciamentoExportacaoPageAereo';
import AgenciamentoExportacaoPageMaritmo from '../pages/module/agenciamento/AgenciamentoExportacaoPageMaritmo';

const SEPARATOR = '/';

// const main = {
//   base: null,
//   access: null,
//   routes: [
//     {
//       path: [],
//       component: HomePage,
//     },
//   ],
// };

const registrations = {
  base: i18n.t('com.muralis.qcx.routes.cadastros'),
  access: ModuloPerfilUtils.CADASTROS,
  routes: [
    {
      path: [i18n.t('com.muralis.qcx.routes.gerais')],
      component: GeneralRegistrationsPage,
    },
    {
      path: [i18n.t('com.muralis.qcx.routes.operacionais')],
      component: OperationalRegistrationsPage,
    },
    {
      path: [i18n.t('com.muralis.qcx.routes.financeiros')],
      component: FinancialRegistrationsPage,
    },
  ],
};

const importacao = {
  base: i18n.t('com.muralis.qcx.routes.importacao'),
  access: ModuloPerfilUtils.IMPORTACAO,
  routes: [
    {
      path: [i18n.t('com.muralis.qcx.routes.desembaraco')],
      component: ImportPage,
    },

    {
      path: [i18n.t('com.muralis.qcx.routes.agenciamento'), 'maritimo'],
      component: AgenciamentoImportacaoPageMaritmo,
    },
    {
      path: [i18n.t('com.muralis.qcx.routes.agenciamento'), 'aereo'],
      component: AgenciamentoImportacaoPageAereo,
    },
  ],
};


const exportacao = {
  base: i18n.t('com.muralis.qcx.routes.exportacao'),
  access: ModuloPerfilUtils.EXPORTACAO,
  routes: [
    {
      path: [],
      component: ExportPage,
    },

    {
      path: [i18n.t('com.muralis.qcx.routes.agenciamento'), 'maritimo'],
      component: AgenciamentoExportacaoPageMaritmo,
    },
    {
      path: [i18n.t('com.muralis.qcx.routes.agenciamento'), 'aereo'],
      component: AgenciamentoExportacaoPageAereo,
    },
  ],
};

const financeiro = {
  base: i18n.t('com.muralis.qcx.routes.financeiro'),
  access: ModuloPerfilUtils.FINANCEIRO,
  routes: [
    {
      path: [],
      component: FinancialPage,
    },
  ],
};


const pricing = {
  base: i18n.t('com.muralis.qcx.routes.pricing'),
  access : ModuloPerfilUtils.CADASTROS,
  routes: [
    {
      path: ["tarifarios"],
      component: PricingTarifarioModulePage,
    }
  ],
};

export default function useRoutes() {
  const map = ({ base, routes, access }) => routes.map(({ path, component }) => ({
    path: SEPARATOR.concat([base, ...path].join(SEPARATOR)),
    access,
    component,
  }));

  return [
    // ...map(main),
    ...map(registrations),
    ...map(importacao),
    ...map(exportacao),
    ...map(financeiro),
    ...map(pricing),
  ];
}
